const STORAGE_KEY = 'oauth_next';

export function saveNextUrl(next: string) {
  if (!next.startsWith('/')) {
    return;
  }

  try {
    sessionStorage.setItem(STORAGE_KEY, next);
  } catch {
    // ignore storage issues
  }

  try {
    localStorage.setItem(STORAGE_KEY, next);
  } catch {
    // ignore storage issues
  }
}

export function readNextUrl(): string | null {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY);
    if (value && value.startsWith('/')) {
      return value;
    }
  } catch {
    // ignore storage issues
  }

  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (value && value.startsWith('/')) {
      return value;
    }
  } catch {
    // ignore storage issues
  }

  return null;
}

export function popNextUrl(): string | null {
  const next = readNextUrl();

  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore storage issues
  }

  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore storage issues
  }

  return next;
}

export function getNextFromQuery(search: URLSearchParams): string | null {
  const next = search.get('next');
  return next && next.startsWith('/') ? next : null;
}
